import React, { useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from '@material-ui/core/Grid';
import { scopesReportsStyles } from './styles';
import { ScopesPermissionsComponent } from '../scopes-permissions-component';
import { useTheme } from '@material-ui/core/styles';
import TabPanel from '../tab-panel';
import ReportsPermissionsComponent from '../reports-permissions/reports-permissions-component';

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`
  };
}

export default function ScopesReportsContainer({ user }) {
  const classes = scopesReportsStyles();
  const theme = useTheme();

  const [tab, setTab] = useState(0);

  const handleChange = (_, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Grid container className={classes.container}>
      <AppBar position="static" color="default">
        <Tabs
          value={tab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="User Scopes" {...a11yProps(0)} />
          <Tab label="User Reports" {...a11yProps(1)} />
        </Tabs>
      </AppBar>

      <TabPanel
        value={tab}
        index={0}
        // @ts-ignore
        dir={theme.direction}
      >
        <ScopesPermissionsComponent user={user} />
      </TabPanel>

      <TabPanel
        value={tab}
        index={1}
        // @ts-ignore
        dir={theme.direction}
      >
        <ReportsPermissionsComponent user={user} />
      </TabPanel>
    </Grid>
  );
}
